import { useMemo } from 'react';

import { useIsMsk } from '@r1-frontend/entities/Layout/_deps/helpers/hooks/useIsMsk';

import { USER_LOGIN_ROUTE } from '@r1-frontend/shared/constants/routes';

const REQUEST_ADDRESS_ROUTE = '/request/address';

interface IUseFoterLinks {
    hasInternet: boolean,
    hasCtv: boolean,
    hasKtv: boolean,
    hasVideocontrol: boolean,
    hasDomofon: boolean,
    domain: string,
}

export const useFooterLinks = ({ hasInternet, hasCtv, hasKtv, hasVideocontrol, hasDomofon, domain }: IUseFoterLinks) => {
    const isMsk = useIsMsk();

    const servicesLinks = useMemo(() => {
        const services = [];

        if (hasInternet && (hasKtv || hasCtv)) {
            services.push({
                text: 'Интернет + ТВ',
                link: isMsk ? '/landing-promo/msk-tariffs' : '/bundles',
            });
        }
        if (hasInternet) {
            services.push({
                text: 'Интернет для квартиры',
                link: isMsk ? '/landing-promo/msk-tariffs' : '/internet',
            });
        }
        if (hasKtv && !isMsk) {
            services.push({
                text: 'Интернет для дачи',
                link: '/internet/na-dachu',
            });
        }
        if (hasCtv) {
            services.push({
                text: 'Цифровое ТВ',
                link: '/movix-new',
            });
        }
        if (hasKtv && !isMsk) {
            services.push({
                text: 'Кабельное ТВ',
                link: '/domru-tv/ktv',
            });
        }
        if (hasVideocontrol) {
            services.push({
                text: 'Видеонаблюдение',
                link: '/videocontrol',
            });
        }
        if (hasDomofon) {
            services.push({
                text: 'Домофон',
                link: '/domofon',
            });
        }
        return services;
    }, [hasInternet, hasKtv, hasCtv, isMsk, hasVideocontrol, hasDomofon]);

    const aboutCompanyLinks = useMemo(() => {
        return [
            {
                text: 'О компании',
                link: '/about',
            },
            {
                text: 'Вакансии Дом.ру',
                link: 'https://job.ertelecom.ru/',
            },
            {
                text: 'Новости',
                link: '/news',
            },
            {
                text: 'Контакты',
                link: '/service/contact',
            },
        ];
    }, [domain]);

    const otherLinks = useMemo(() => {
        return [
            {
                text: 'Дом.ру Бизнес',
                link: `https://${domain}.b2b.dom.ru`,
            },
            {
                text: 'Приставка Movix Pro',
                link: '/movix-new',
            },
            {
                text: 'Личный кабинет',
                link: USER_LOGIN_ROUTE,
            },
            {
                text: 'Партнерская программа Дом.ру',
                link: `https://${domain}.dom.ru/dealers/mania/?_ga=2.7658354.1198776689.1557729339-2075692635.1557729339`,
            },
            {
                text: 'Проверка адреса подключения',
                link: REQUEST_ADDRESS_ROUTE,
            },
            {
                text: 'Отзывы клиентов',
                link: '/reviews',
            },
        ];
    }, [domain]);

    return useMemo(() => ({
        services: servicesLinks,
        info: [
            {
                title: 'Дом.ру',
                linkList: aboutCompanyLinks,
                key: 'links-domru',
            },
            {
                title: 'Прочее',
                linkList: isMsk ? [...otherLinks].filter(elem => elem.link !== REQUEST_ADDRESS_ROUTE) : otherLinks,
                key: 'links-other',
            },
        ],
    }), [aboutCompanyLinks, isMsk, otherLinks, servicesLinks]);
};
